import { Typography, useTheme } from '@mui/material';
import { TagChip } from 'components/ui';
import { TableContext } from 'pages/PatientsPage';
import { carePlansList } from 'pages/PatientsPage/PatientsFilter/Filters/CarePlanFilter';
import { Fragment, useContext } from 'react';
import { useTranslation } from 'react-i18next';

export const CarePlanFilterChip = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { filters, setFilters } = useContext(TableContext);

  function deleteCategoryFilter(category) {
    setFilters({
      ...filters,
      [category]: null,
    });
  }

  function deleteCarePlanFilter(category, carePlan) {
    const newCarePlanFilter = filters?.[category]?.filter(
      (item) => item.id !== carePlan.id
    );
    setFilters({
      ...filters,
      [category]: newCarePlanFilter,
    });
  }

  return carePlansList.map((carePlanFilter) =>
    filters?.[carePlanFilter.value] ? (
      <Fragment key={carePlanFilter.value}>
        <TagChip
          tag={
            <>
              <Typography
                component="span"
                color={theme.palette.colors.black}
                fontSize={'0.875rem'}
                fontWeight={'500'}
              >
                {`${t('Care plan')}: `}
              </Typography>
              <Typography
                component="span"
                color={theme.palette.colors.blue100}
                fontSize={'0.875rem'}
                fontWeight={'500'}
              >
                {t(carePlanFilter.label)}
              </Typography>
            </>
          }
          handleDelete={() => deleteCategoryFilter(carePlanFilter.value)}
          isCanDelete
          iconColor={theme.palette.colors.blue100}
        />
        {filters?.[carePlanFilter.value] === true
          ? null
          : filters?.[carePlanFilter.value]?.map((selectedActiveCarePlan) => (
              <TagChip
                key={selectedActiveCarePlan.id}
                tag={
                  <>
                    <Typography
                      component="span"
                      color={theme.palette.colors.black}
                      fontSize={'0.875rem'}
                      fontWeight={'500'}
                    >
                      {`${t('Care plan')}: `}
                    </Typography>
                    <Typography
                      component="span"
                      color={theme.palette.colors.blue100}
                      fontSize={'0.875rem'}
                      fontWeight={'500'}
                    >
                      {selectedActiveCarePlan.title}
                    </Typography>
                  </>
                }
                handleDelete={() =>
                  deleteCarePlanFilter(
                    carePlanFilter.value,
                    selectedActiveCarePlan
                  )
                }
                isCanDelete
                iconColor={theme.palette.colors.blue100}
              />
            ))}
      </Fragment>
    ) : null
  );
};
